/** Default width as a fraction of the viewport (left and right asides). */
export const ASIDE_WIDTH_DEFAULT_RATIO = 0.25

export const ASIDE_WIDTH_MIN_PX = 300
export const ASIDE_WIDTH_MAX_PX = 520

/** localStorage key for manually resized left aside width (px). Absent = follow 25% viewport. */
export const LEFT_ASIDE_WIDTH_STORAGE_KEY = 'rtu-left-aside-width-px'

/** localStorage key for manually resized right chat aside width (px). Absent = follow 25% viewport. */
export const RIGHT_ASIDE_WIDTH_STORAGE_KEY = 'rtu-right-aside-width-px'
